import { RefObject, useEffect } from 'react';
import noop from 'lodash/noop';
import { useDispatch, useSelector } from 'react-redux';

import {
  selectShowDisableThreadNotAllowedModal,
  setShowDisableThreadNotAllowedModal,
} from 'src/presentation/components/pages/sidekick/threads/actions/threadsUiSlice';
import { enableThread } from 'src/presentation/components/pages/sidekick/threads/actions/threadActions';
import { ModalWrapperRef } from 'src/presentation/components/pages/sidekick/threads/components/ModalWrapper';

const useHandleActivate = ({
  modalRef,
  setThread,
}: {
  modalRef?: RefObject<ModalWrapperRef>;
  setThread?: (value) => void;
}) => {
  const dispatch = useDispatch();

  const showDisableThreadNotAllowedModal = useSelector(selectShowDisableThreadNotAllowedModal);

  useEffect(() => {
    if (showDisableThreadNotAllowedModal) {
      dispatch(setShowDisableThreadNotAllowedModal(false));

      modalRef?.current?.show({
        subscribe: () => {
          noop;
        },
      });
    }
  }, [dispatch, modalRef, showDisableThreadNotAllowedModal]);

  const toggleEnabledHandler = item => {
    setThread && setThread(item);
    dispatch(enableThread({ threadId: item.id, enabled: !item.enabled }));
  };

  return {
    toggleEnabledHandler,
  };
};

export default useHandleActivate;
